import { Header } from 'components/slider/header';
import Link from 'next/link';

import { Icon } from 'common/icon';

import { CasinoInspectionsProps } from 'constants/templates';
import { Anchor } from 'constants/anchors';
import { ICasino } from 'constants/types';
import styles from './styles.module.css';
import { Analytics } from 'constants/analytics';

const variantsIcon = {
  comment: 'comment',
  search: 'search',
  trophy: 'trophy',
};

export const CasinoInspectionsItem = ({
  id,
  data,
}: {
  id?: string;
  data: CasinoInspectionsProps;
}) => {
  const renderIcon = (icon: string) => {
    switch (icon) {
      case variantsIcon.comment:
        return <Icon.Comment />;
      case variantsIcon.trophy:
        return <Icon.Trophy />;
      case variantsIcon.search:
        return <Icon.Search />;
      default:
        return null;
    }
  };

  return (
    <Link
      href={data?.url ?? ''}
      id={id}
      className={styles.casino_inspections__item}
    >
      <div className={styles.casino_inspections__item_wrapper}>
        <h3 className={styles.casino_inspections__item_info}>
          <div className={styles.casino_inspections__item_name}>
            <h3>{data?.name}</h3>
          </div>
          <div className={styles.casino_inspections__item_amount}>
            {renderIcon(data.icon)}
            <span>{data.count}</span>
          </div>
          <div className={styles.casino_inspections__item_thing}>
            <p>{data.description}</p>
          </div>
        </h3>
        <div className={styles.casino_inspections__item_arrow}>
          <Icon.Arrow width={30} height={30} fillOpacity="0.4" />
        </div>
      </div>
    </Link>
  );
};

export const CasinoInspections = ({ data }: { data: ICasino }) => {
  const dataCasinoInspections: CasinoInspectionsProps[] = [
    {
      id: Analytics.casino.inspectAllPlayerReviews,
      name: data?.name,
      icon: 'comment',
      description: 'casino reviews',
      count: data?.casinos_reviews_count?.toString(),
      url: `#${Anchor.CasinoReviews}`,
    },
    {
      id: Analytics.casino.inspectAllSlotsRtpReviews,
      name: data?.name,
      icon: 'search',
      description: 'slots RTP reviews',
      count: (data?.slots_reviews_count ?? 0)?.toString() ?? 0,
      url: `#${Anchor.slot.reviews}`,
    },
  ];

  return (
    <>
      <section className={styles.casino_inspections}>
        <div className={styles.container_s}>
          <div id={Anchor.Inspect} className="anchor" />
          <Header
            hasIcon={false}
            name={`${'All'} ${data?.name} ${'inspections'}`}
            count={(
              data?.casinos_reviews_count + data?.slots_reviews_count
            )?.toString()}
          />
          <div className={styles.casino_inspections__row}>
            {dataCasinoInspections?.map((item) => (
              <CasinoInspectionsItem
                id={item.id.toString()}
                key={item.id.toString()}
                data={item}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
